export default "__VITE_ASSET__DkNvE3y___"